import React, { useEffect, useState } from "react";
import { onSnapshot, collection } from "firebase/firestore";

import { db } from "../../firebaseConfig";

const truncateWalletAddress = (address: string) => {
  const maxLength = 10; // Number of characters to show at the beginning and end
  if (address.length <= maxLength * 2) return address;
  return `${address.slice(0, maxLength)}......${address.slice(-maxLength)}`;
};

const Leaderboard: React.FC = () => {
  const [leaders, setLeaders] = useState<any>(null);

  const getAllData = (
    collectionName: string,
    callback: (data: any[] | undefined) => void
  ) => {
    const colRef = collection(db, collectionName);

    const unsubscribe = onSnapshot(
      colRef,
      (snapshot) => {
        const data = snapshot.docs.map((doc) => doc.data());
        callback(data);
      },
      (error) => {
        console.error("Error getting real-time updates: ", error);
        callback(undefined);
      }
    );

    return unsubscribe;
  };

  useEffect(() => {
    const unsubscribe = getAllData("leaderboard", (newData) => {
      const sorted = newData
        ?.sort((a, b) => b.totalValue - a.totalValue)
        .slice(0, 10);

      setLeaders(sorted);
    });

    // Cleanup subscription on unmount
    return () => unsubscribe();
  }, []);

  return (
    <figure>
      <h2 className="text-3xl md:text-4xl font-bold text-white capitalize mb-6">
        Top 10 Staker
      </h2>
      <div className="w-full overflow-auto">
        <table className="min-w-full bg-gray-900 border border-primary rounded-md shadow-md text-center">
          <thead>
            <tr>
              <th className="py-2 px-4 bg-body border-b border-primary">
                Rank
              </th>
              <th className="py-2 px-4 bg-body border-b border-primary">
                Wallet Address
              </th>
              <th className="py-2 px-4 bg-body border-b border-primary">
                Amount Earned
              </th>
            </tr>
          </thead>
          <tbody>
            {leaders &&
              leaders.map((stacker: any, index: any) => (
                <tr
                  key={stacker.ownerWallet}
                  className="border-b border-primary"
                >
                  <td className="py-2 px-4">{index + 1}</td>
                  <td className="py-2 px-4">
                    {truncateWalletAddress(stacker?.id)}
                  </td>
                  <td className="py-2 px-4 font-bold">{stacker?.totalValue}</td>
                </tr>
              ))}
          </tbody>
        </table>
      </div>
    </figure>
  );
};

export default Leaderboard;
